export class SearchFilter {
  fromDate: Date;
  toDate: Date;
  reportName: string;
  reportHighlights: string;
  keyword: string;
  categoryIds: number[] = new Array<number>();
  postIds: number[] = new Array<number>();
  postNames: string[] = new Array<string>();
  countryIds: number[] = new Array<number>();
}

export class SearchResult {
  reportId: string;
  reportName?: string;
  reportHighlights: string;
  publishDate?: Date;
  reportDate: Date;
  postName: string;
  isPublic: boolean;
  isLegacy: boolean;
  fileName: string;
  countryName: string;
  reportCategory: string;
  reportNumber: string;
  reportStateId: number;
  reportState: string;
  approvedSentToWashingtonDate: Date;
}

export class QuickLinkResult{
  reportId :string;
  reportName :string;
  fileName :string;
  fileExtension:string;
  countryName:string;
  postName:string;
  publishedOn:Date;
  isRequired:boolean;
  isPublic:boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/search.model.ts